/**
 * <chz-channels>: pestañas con forma de canales de TV. Al cambiar de canal, la pantalla muestra
 * estática un instante (solo si la persona no pidió menos movimiento). Teclado: flechas, Inicio y Fin.
 */
class ChzChannels extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.addEventListener('click', (event) => {
      const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
      if (tab instanceof HTMLElement && this.contains(tab)) this.select(tab);
    }, { signal });
    this.addEventListener('keydown', (event) => {
      const tabs = this.#tabs();
      const index = tabs.indexOf(/** @type {HTMLElement} */ (document.activeElement));
      if (index < 0) return;
      let next = -1;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next >= 0) {
        event.preventDefault();
        this.select(tabs[next]);
        tabs[next].focus();
      }
    }, { signal });
  }

  disconnectedCallback() {
    this.#abort.abort();
  }

  #tabs() {
    return /** @type {HTMLElement[]} */ ([...this.querySelectorAll('[role="tab"]')]);
  }

  /** @param {HTMLElement} tab */
  select(tab) {
    for (const t of this.#tabs()) {
      const selected = t === tab;
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
      const panel = this.querySelector(`#${t.getAttribute('aria-controls')}`);
      if (panel instanceof HTMLElement) panel.hidden = !selected;
    }
    const screen = this.querySelector(`#${tab.getAttribute('aria-controls')} .chz-tv__screen`);
    if (screen instanceof HTMLElement) {
      screen.classList.remove('is-switching');
      void screen.offsetWidth;
      screen.classList.add('is-switching');
    }
  }
}

if (!customElements.get('chz-channels')) customElements.define('chz-channels', ChzChannels);
